import React, { useContext } from "react";
import { Pet } from "../../types";
import { PetImage } from "../PetImage";
import { PetInfo } from "../PetInfo";
import { PetsContext } from "../PetsProvider";

export const PetCard = ({
  pet,
  position,
  petList,
}: {
  pet: Pet;
  position: number;
  petList: Pet[];
}) => {
  const { imageSrc, name, petType } = pet;
  const { handleRemovePreviousPets, pets } = useContext(PetsContext);

  return (
    <div
      className="pet-card"
      onClick={() =>
        handleRemovePreviousPets({ index: position, pets, petList })
      }
    >
      <PetImage imageSrc={imageSrc} altValue={name} />
      <PetInfo name={name} petType={petType} />
    </div>
  );
};
